import { useQuery } from 'react-query'
import { notification } from 'antd'

import { QUERY_KEYS } from '@api'

import { SupplierPurchaseOrdersApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los materiales',
  })
}

const useSupplierPurchaseOrders = () => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.PURCHASES],
    () => SupplierPurchaseOrdersApi.getSupplierPurchaseOrder(),
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    purchaseOrders: data,
    isLoading,
  }
}

export { useSupplierPurchaseOrders }
